<template>
  <div id="transfer">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div>
      <div>
        <div class="content">
          <div>
            <div class="account border-bottom"  @click="goClientList">
              <div>
                <span>对方账户</span>
                <input type="text" placeholder="用户名/手机号" v-model="phone"  readonly="readonly">
              </div>
                <i class="iconfont">&#xe60f;</i>
            </div>
            <div class="cue">
              <p>钱将实时转入对方账户，无法退款</p>
            </div>
            <div class="account goods-btn" @click="selectItem" >
              <div class="select-title">
                <span>选择商品</span>
              </div>
                <i class="iconfont">&#xe60f;</i>
            </div>
            <div class="goods-list">
              <div class="goods-item" v-for="(item,index) in goodsList" :key="index">
                <img class="goods-img" :src="item.img ? url + item.img : defaultimg" />
                <div class="goods-title">{{item.title}}</div>
                <div class="goods-count">X{{item.count}}</div>
              </div>
            </div>
          </div>
          <div class="transfer-price">
            <p>转账金额<span>（收取收款方2%手续费）</span></p>
            <div class="content-price border-bottom">
              <span>￥</span>
              <input type="text" v-model="price">
            </div>
            <div class="transfer">
              <p>可转账金额：<span>{{body.isTransferAmount}}</span></p>
              <button @click="handleAllTransfer">全部转出</button>
            </div>
            <input class="explain" autocomplete="off" v-model="summary" placeholder="添加转账说明">
          </div>
          <div class="password">
            <input type="password" autocomplete="off" placeholder="请输入支付密码" v-model="password">
          </div>
        </div>
        <div class="footer">
          <button type="submit" @click="handleTransferClick">{{state}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'TransferMess',
  props: {
    body: [Object, String]
  },
  data () {
    return {
      phone: '',
      price: '',
      password: '',
      state: '转账',
      summary: '',
      url,
      goodsList: [],
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.push({
        path: '/me'
      })
    },
    handleAllTransfer () {
      this.price = JSON.parse(this.body.isTransferAmount)
    },
    handleTransferClick () {
      this.state = '转账中...'
      this.bus.$emit('loading', true)
      this.transferaccount()
      // 反馈
    },
    // 验证
    transferaccount () {
      if (this.phone === '') {
        alert('请输入对方账户')
        return
      } else if (this.price === '') {
        alert('请输入转账金额')
        return
      } else if (this.price <= 0 || this.price > JSON.parse(this.body.isTransferAmount)) {
        alert('请输入正确的转账金额')
        return
      } else if (this.password === '') {
        alert('请输入支付密码')
        return
      }
      let goods = []
      for (let i = 0; i < this.goodsList.length; i++) {
        let item = this.goodsList[i]
        let temp = {
          id: parseInt(item.id),
          num: item.count
        }
        goods.push(temp)
      }
      this.axios.post('/ApiMe/AccountTransfer', {
        MemberName: this.phone,
        TransferAmount: this.price,
        PayPassword: this.password,
        Summary: this.summary,
        gooList: goods
      }).then(this.postTranInfoSucc)
        .catch(this.postTranInfoFail)
    },
    // 提交
    postTranInfoSucc (res) {
      this.state = '再次转账'
      res = res.data
      if (res.errorInfo === '') {
        alert('转账成功')
        this.$router.push({
          path: '/me'
        })
      } else if (res.errorInfo.indexOf('未设置支付密码') > 0) {
        alert(res.errorInfo)
        this.$router.push({
          path: '/revise_pay_password'
        })
      } else {
        alert(res.errorInfo)
      }
    },
    postTranInfoFail () {
      alert('转账失败')
    },
    /* 选择客户 */
    goClientList () {
      this.$router.push({
        path: '/clientlist'
      })
    },
    selectItem () {
      if (this.phone === '') {
        alert('请选择手机号')
        return
      }
      this.$router.push({
        path: '/transferitem',
        query: {
          userName: this.phone
        }
      })
    }
  },
  mounted () {
    let clientInfo = this.$route.query.clientInfo || {}
    this.phone = clientInfo.account || ''
    this.goodsList = clientInfo.itemList || []
  }
}
</script>

<style scoped>
#transfer{ min-height: 100%;}
.header{ display: flex; justify-content: space-between; align-items: center; padding: 10px 15px;}
.header a{ text-decoration: none; color: #333;}
.header .iconfont{ font-size: 25px;}
.content{ border-top: 10px solid #f2f2f2; padding: 0 15px;}
.account{ display: flex; align-items: center;justify-content: space-between;}
.account input{ border: 0; height: 40px; padding-left: 10px; line-height: 20px;}
.account .iconfont{font-size: 18px;}
input::-webkit-input-placeholder{ color:#bdbdbd; font-size: 14px; font-weight: normal; line-height: 15px; font-family: Arial,"Microsoft YaHei";}
.cue{ margin: 10px 0 20px;}
.cue p{ font-size: 12px; color: #a2a2a2;}
.footer{ margin-top: 15px;}
.footer a{ text-decoration: none;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 40px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.header{ padding: 10px 15px; padding-bottom: 5px;}
.header .iconfont{ font-size: 25px;}
.content{ padding: 20px 15px; padding-top: 25px;}
.content-img{ display: flex; flex-direction: column; align-items: center;}
.content-img img{ width: 60px; height: 60px;}
.content-img p{ color: #b0b0b0;}
.transfer-price span{ color: #999;}
.content-price span{ font-size: 25px; font-weight: bold; color: #333;}
.content-price input{ border: 0; height: 30px; font-size: 20px; padding-bottom: 10px;}
.transfer-price p{ margin: 15px 0;}
.transfer-price .explain{padding-left: 5px;width: 98%;height: 30px;line-height: 30px;border: 1px solid #e5e5e5; font-family: Arial,"Microsoft YaHei"; margin-top: 10px; margin-bottom: 0;font-size: 13px;}
input::placeholder{ color: #aca9a9; font-size: 13px;}
.footer a{ text-decoration: none;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 40px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.transfer{ display: flex; align-items: center;}
.transfer button{margin-left: 11px;border-radius: 5px; background: #EE2526; color: #fff; padding:6px 8px; font-size: 14px;border-radius: 5px;}
.password{ border: 1px solid #e5e5e5; margin-top: 20px; width: 98%; height: 30px; line-height: 30px; padding-left: 5px;}
.select-item {
  margin: 20px 0;
  width: 80%; margin-right: auto; margin-left: auto; background-color: rgb(14, 79, 219); color: #fff; display: block; border: 0; height: 40px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";
}
.goods-btn{
  margin-bottom: 10px;
}
.goods-item{
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  padding-right: 15px;
  border-radius: 5px;
  background: #f5f5f5;
  overflow: hidden;
}
.goods-img{
  display: flex;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}
.goods-title{
  margin: 0 12px;
  flex-grow: 1;
  font-size: 12px;
  color: #666666;
}
.goods-count{
  flex-shrink: 0;
  font-size: 12px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/pages/transfer/components/Mess.vue